"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = ({
  title: i,
  titleId: t,
  desc: n,
  descId: r,
  ...o
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": r,
    ...o,
    children: [
      i ? /* @__PURE__ */ e("title", { id: t, children: i }) : null,
      n === void 0 ? /* @__PURE__ */ e("desc", { id: r, children: `
    Water Sun Streamline Icon: https://streamlinehq.com
  ` }) : n ? /* @__PURE__ */ e("desc", { id: r, children: n }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M14.3372 10.763c-1.0855-.2558-1.644-.8842-2.106-1.5831-.2894-.438-.926-.4113-1.2404.009-.719.961-1.7922 1.7297-3.4908 1.7297-1.7138 0-2.791-.978-3.5099-1.8984-.3003-.3845-.8753-.3793-1.1383.0317-.4792.7492-1.0376 1.4398-2.189 1.711M14.3372 14.1816c-1.0855-.2559-1.644-.8842-2.106-1.5831-.2894-.438-.926-.4114-1.2404.009-.719.961-1.7922 1.7297-3.4908 1.7297-1.7138 0-2.791-.978-3.5099-1.8984-.3003-.3844-.8753-.3793-1.1383.0317-.4792.7492-1.0376 1.4398-2.189 1.711"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M11.5456 6.8163C11.2201 4.8761 9.5326 3.3977 7.5 3.3977S3.78 4.876 3.4544 6.8163M7.5.6628v.6838M14.3372 7.5h-.6837M1.3465 7.5H.6628M12.3341 2.6656l-.2685.2686M2.9343 2.934l-.2686-.2686"
        }
      )
    ]
  }
);
export {
  d as default
};
